import { NavigationRoutes } from 'common/constants';
import { NavigatorParams } from 'common/constants/navigator-params';
import { NavigationParams } from 'containers/hooks/types';
import { useRouter } from 'next/router';
import { ParsedUrlQueryInput } from 'querystring';
import React from 'react';

function previousRouteName(route: NavigationRoutes) {
  switch (route) {
    case NavigationRoutes.Reschedule:
      return undefined;
    case NavigationRoutes.ApprovalItemsList:
    case NavigationRoutes.ApprovalItemsView:
      return NavigationRoutes.ApprovalItemsList;
    case NavigationRoutes.UpgradeList:
    case NavigationRoutes.UpgradeCreate:
    case NavigationRoutes.UpgradeView:
      return NavigationRoutes.UpgradeList;
    case NavigationRoutes.TourSalesList:
    case NavigationRoutes.TourSalesCreate:
    case NavigationRoutes.ToursalesView:
      return NavigationRoutes.TourSalesList;
    case NavigationRoutes.TourList:
    case NavigationRoutes.TourCreate:
    case NavigationRoutes.TourView:
      return NavigationRoutes.TourList;
    case NavigationRoutes.ProjectList:
    case NavigationRoutes.ProjectCreate:
    case NavigationRoutes.ProjectView:
      return NavigationRoutes.ProjectList;
    case NavigationRoutes.CommissionList:
    case NavigationRoutes.CommissionCreate:
    case NavigationRoutes.CommissionView:
      return NavigationRoutes.CommissionList;
    case NavigationRoutes.TippingList:
    case NavigationRoutes.TippingCreate:
    case NavigationRoutes.TippingView:
      return NavigationRoutes.TippingList;
    case NavigationRoutes.ChequeGiroClearingsList:
    case NavigationRoutes.ChequeGiroClearingsCreate:
    case NavigationRoutes.ChequeGiroClearingsView:
      return NavigationRoutes.ChequeGiroClearingsList;
    case NavigationRoutes.IncomeCostsList:
    case NavigationRoutes.IncomeCostsCreate:
    case NavigationRoutes.IncomeCostsView:
      return NavigationRoutes.IncomeCostsList;
    case NavigationRoutes.BalanceAdjustmentsList:
    case NavigationRoutes.BalanceAdjustmentsCreate:
    case NavigationRoutes.BalanceAdjustmentsView:
      return NavigationRoutes.BalanceAdjustmentsList;
    case NavigationRoutes.TransfersList:
    case NavigationRoutes.TransfersCreate:
    case NavigationRoutes.TransfersView:
      return NavigationRoutes.TransfersList;
    case NavigationRoutes.CashTransactionsList:
    case NavigationRoutes.CashTransactionsCreate:
    case NavigationRoutes.CashTransactionsView:
      return NavigationRoutes.CashTransactionsList;
    case NavigationRoutes.BankTransactionsList:
    case NavigationRoutes.BankTransactionsCreate:
    case NavigationRoutes.BankTransactionsView:
      return NavigationRoutes.BankTransactionsList;
    case NavigationRoutes.OrderAdjustmentList:
    case NavigationRoutes.OrderAdjustmentCreate:
    case NavigationRoutes.OrderAdjustmentView:
      return NavigationRoutes.OrderAdjustmentList;
    case NavigationRoutes.TicketSalesList:
    case NavigationRoutes.TicketSalesCreate:
    case NavigationRoutes.TicketSalesView:
      return NavigationRoutes.TicketSalesList;
    case NavigationRoutes.HotelSalesList:
    case NavigationRoutes.HotelSalesCreate:
    case NavigationRoutes.HotelSalesView:
      return NavigationRoutes.HotelSalesList;
    case NavigationRoutes.CruiseSalesList:
    case NavigationRoutes.CruiseSalesCreate:
    case NavigationRoutes.CruiseSalesView:
      return NavigationRoutes.CruiseSalesList;
    case NavigationRoutes.ActivitySalesList:
    case NavigationRoutes.ActivitySalesCreate:
    case NavigationRoutes.ActivitySalesView:
      return NavigationRoutes.ActivitySalesList;
    case NavigationRoutes.FlightPurchasesList:
    case NavigationRoutes.FlightPurchasesCreate:
    case NavigationRoutes.FlightPurchasesView:
      return NavigationRoutes.FlightPurchasesList;
    case NavigationRoutes.TravelDocumentSalesList:
    case NavigationRoutes.TravelDocumentSalesCreate:
    case NavigationRoutes.TravelDocumentSalesView:
      return NavigationRoutes.TravelDocumentSalesList;
    case NavigationRoutes.HotelPurchasesList:
    case NavigationRoutes.HotelPurchasesCreate:
    case NavigationRoutes.HotelPurchasesView:
      return NavigationRoutes.HotelPurchasesList;
    case NavigationRoutes.CruisePurchasesList:
    case NavigationRoutes.CruisePurchasesCreate:
    case NavigationRoutes.CruisePurchasesView:
      return NavigationRoutes.CruisePurchasesList;
    case NavigationRoutes.DocumentPurchasesList:
    case NavigationRoutes.DocumentPurchasesCreate:
    case NavigationRoutes.DocumentPurchasesView:
      return NavigationRoutes.DocumentPurchasesList;
    case NavigationRoutes.ActivityPurchasesList:
    case NavigationRoutes.ActivityPurchasesCreate:
    case NavigationRoutes.ActivityPurchasesView:
      return NavigationRoutes.ActivityPurchasesList;
    case NavigationRoutes.CostsList:
    case NavigationRoutes.CostsCreate:
    case NavigationRoutes.CostsView:
      return NavigationRoutes.CostsList;
    case NavigationRoutes.RevenuesList:
    case NavigationRoutes.RevenuesCreate:
    case NavigationRoutes.RevenuesView:
      return NavigationRoutes.RevenuesList;
    case NavigationRoutes.PreferenceTagsList:
    case NavigationRoutes.PreferenceTagsCreate:
    case NavigationRoutes.PreferenceTagsView:
      return NavigationRoutes.PreferenceTagsList;
    case NavigationRoutes.EmployeesList:
    case NavigationRoutes.EmployeesCreate:
    case NavigationRoutes.EmployeesView:
      return NavigationRoutes.EmployeesList;
    case NavigationRoutes.RolesList:
    case NavigationRoutes.RolesCreate:
    case NavigationRoutes.RolesView:
      return NavigationRoutes.RolesList;
    case NavigationRoutes.CustomersList:
    case NavigationRoutes.CustomersCreate:
    case NavigationRoutes.CustomersView:
      return NavigationRoutes.CustomersList;
    case NavigationRoutes.AgentsList:
    case NavigationRoutes.AgentsCreate:
    case NavigationRoutes.AgentsView:
      return NavigationRoutes.AgentsList;
    case NavigationRoutes.GuestsList:
    case NavigationRoutes.GuestsCreate:
    case NavigationRoutes.GuestsView:
      return NavigationRoutes.GuestsList;
    case NavigationRoutes.ApprovalMastersList:
    case NavigationRoutes.ApprovalMastersCreate:
    case NavigationRoutes.ApprovalMastersView:
      return NavigationRoutes.ApprovalMastersList;
    case NavigationRoutes.AirlinesList:
    case NavigationRoutes.AirlinesCreate:
    case NavigationRoutes.AirlinesView:
      return NavigationRoutes.AirlinesList;
    case NavigationRoutes.HotelsList:
    case NavigationRoutes.HotelsCreate:
    case NavigationRoutes.HotelsView:
      return NavigationRoutes.HotelsList;
    case NavigationRoutes.CruisesList:
    case NavigationRoutes.CruisesCreate:
    case NavigationRoutes.CruisesView:
      return NavigationRoutes.CruisesList;
    case NavigationRoutes.ActivitiesList:
    case NavigationRoutes.ActivitiesCreate:
    case NavigationRoutes.ActivitiesView:
      return NavigationRoutes.ActivitiesList;
    case NavigationRoutes.TourCategoryList:
    case NavigationRoutes.TourCategoryCreate:
    case NavigationRoutes.TourCategoryView:
      return NavigationRoutes.TourCategoryList;
    case NavigationRoutes.ChequeGirosList:
    case NavigationRoutes.ChequeGirosCreate:
    case NavigationRoutes.ChequeGirosView:
      return NavigationRoutes.ChequeGirosList;
    case NavigationRoutes.PaymentChannelsList:
    case NavigationRoutes.PaymentChannelsCreate:
    case NavigationRoutes.PaymentChannelsView:
      return NavigationRoutes.PaymentChannelsList;
    case NavigationRoutes.CashAccountsList:
    case NavigationRoutes.CashAccountsCreate:
    case NavigationRoutes.CashAccountsView:
      return NavigationRoutes.CashAccountsList;
    case NavigationRoutes.BankAccountsList:
    case NavigationRoutes.BankAccountsCreate:
    case NavigationRoutes.BankAccountsView:
      return NavigationRoutes.BankAccountsList;
    case NavigationRoutes.TransactionCategoriesList:
    case NavigationRoutes.TransactionCategoriesCreate:
    case NavigationRoutes.TransactionCategoriesView:
      return NavigationRoutes.TransactionCategoriesList;
    case NavigationRoutes.AccountPayablesList:
    case NavigationRoutes.AccountPayablesCreate:
    case NavigationRoutes.AccountPayablesView:
      return NavigationRoutes.AccountPayablesList;
    case NavigationRoutes.AccountReceivablesList:
    case NavigationRoutes.AccountReceivablesCreate:
    case NavigationRoutes.AccountReceivablesView:
      return NavigationRoutes.AccountReceivablesList;
    case NavigationRoutes.ReceiptsList:
    case NavigationRoutes.ReceiptsCreate:
    case NavigationRoutes.ReceiptsView:
      return NavigationRoutes.ReceiptsList;
    case NavigationRoutes.ProductsList:
    case NavigationRoutes.ProductsCreate:
    case NavigationRoutes.ProductsView:
      return NavigationRoutes.ProductsList;
    case NavigationRoutes.ProductSalesList:
    case NavigationRoutes.ProductSalesCreate:
    case NavigationRoutes.ProductSalesView:
      return NavigationRoutes.ProductSalesList;
    case NavigationRoutes.ProductPurchasesList:
    case NavigationRoutes.ProductPurchasesCreate:
    case NavigationRoutes.ProductPurchasesView:
      return NavigationRoutes.ProductPurchasesList;
    case NavigationRoutes.ProductAdjustmentList:
    case NavigationRoutes.ProductAdjustmentCreate:
    case NavigationRoutes.ProductAdjustmentView:
      return NavigationRoutes.ProductAdjustmentList;
    case NavigationRoutes.RefundList:
    case NavigationRoutes.RefundCreate:
    case NavigationRoutes.RefundView:
      return NavigationRoutes.RefundList;
    case NavigationRoutes.RefundReleaseAgentList:
    case NavigationRoutes.RefundReleaseAgentView:
      return NavigationRoutes.RefundReleaseAgentList;
    case NavigationRoutes.RefundReleaseUserList:
    case NavigationRoutes.RefundReleaseUserView:
      return NavigationRoutes.RefundReleaseUserList;
    case NavigationRoutes.VisaDocumentList:
    case NavigationRoutes.VisaDocumentCreate:
    case NavigationRoutes.VisaDocumentView:
      return NavigationRoutes.VisaDocumentList;
    case NavigationRoutes.BonusPeriodList:
    case NavigationRoutes.BonusPeriodCreate:
    case NavigationRoutes.BonusPeriodView:
      return NavigationRoutes.BonusPeriodList;
    case NavigationRoutes.TourDetailReport:
      return NavigationRoutes.TourReport;
    case NavigationRoutes.AccountReceivableReport:
    case NavigationRoutes.AccountReceivableRegularReport:
    case NavigationRoutes.AccountPayableReport:
    case NavigationRoutes.AccountPayableRegularReport:
    case NavigationRoutes.AgentMutationReport:
    case NavigationRoutes.BankMutationReport:
    case NavigationRoutes.CashMutationReport:
    case NavigationRoutes.CustomerMutationReport:
    case NavigationRoutes.FlightReport:
    case NavigationRoutes.HotelReport:
    case NavigationRoutes.PurchaseReport:
    case NavigationRoutes.SaleReport:
    case NavigationRoutes.TourReport:
    case NavigationRoutes.ProfitLossReport:
    case NavigationRoutes.IncomeReport:
    case NavigationRoutes.ProjectReport:
    case NavigationRoutes.TransactionReport:
    case NavigationRoutes.EmployeeComissionReport:
    case NavigationRoutes.SalesBonusReport:
    case NavigationRoutes.NonSalesBonusReport:
    case NavigationRoutes.PassportReport:
    case NavigationRoutes.VisaReport:
    case NavigationRoutes.ApecCardReport:
    case NavigationRoutes.InsuranceReport:
      return undefined;
    case NavigationRoutes.ChangePassword:
    case NavigationRoutes.Cro:
    case NavigationRoutes.GuestDashboardView:
    default:
      return '/';
  }
}

export default function useNavigation() {
  const { pathname: activeKey, replace, push, back } = useRouter();

  const navigate = React.useCallback(
    (route: NavigationRoutes, params?: NavigationParams[NavigationRoutes]) => {
      const query: ParsedUrlQueryInput = {};
      if (params) {
        Object.keys(params).forEach((key) => {
          const value = params[key];
          if (typeof value === 'string') {
            query[key] = params[key];
          }

          if (typeof value === 'object') {
            if (!['filter', 'sort', 'page'].includes(key)) return;

            Object.keys(value).forEach((subKey) => {
              query[`${key}[${subKey}]`] = value[subKey];
            });
          }
        });
      }

      NavigatorParams.set(route, params, query?.id as string | undefined);
      push({
        pathname: route,
        query,
      });
    },
    [push],
  );

  const close = () => {
    const routeName = previousRouteName(activeKey as NavigationRoutes);
    if (routeName === undefined) return back();
    replace(routeName);
  };

  return {
    activeKey,
    navigate,
    close,
    back,
  };
}
